<p class="instructions-container" i18n>
  Take the photo facing the camera.
</p>
<div class="liveness-container">
  <div class="video-wrapper">
    <video #video id="webcam" autoplay muted [hidden]="takePhotoCompleted"  playsInline> </video>
    <img class="headshoot-photo" src={{finalPhoto}} alt="headshot" photo [hidden]="!takePhotoCompleted">
  </div>
</div>
<div class="button-group-responsive" style="margin-top: 15px;">
  <button class="button button-primary" (click)="back()" i18n="Button label">
    BACK
  </button>
  @if (!takePhotoCompleted) {
    <button class="button button-primary" (click)="takePicture()" i18n="Button label">
      Take Picture
    </button>
  } @else {
    <button class="button button-primary" (click)="retake()" i18n="Button label">
      Retake
    </button>
    <button class="button button-primary" (click)="submit()" i18n="Button label">
      Submit
    </button>
  }
</div>


